import { Link } from 'react-router-dom';
import { Terminal } from 'lucide-react';

export function Footer() {
 const currentYear = new Date().getFullYear();

 return (
  <footer className='border-t border-border bg-black/20 mt-20 font-mono text-xs text-muted-foreground'>
   <div className='max-w-7xl mx-auto px-6 py-12'>
    <div className='grid grid-cols-2 md:grid-cols-4 gap-8 mb-12'>
     {/* Brand Column */}
     <div className='col-span-2 md:col-span-1 space-y-4'>
      <div className='flex items-center gap-2 text-primary font-bold'>
       <Terminal className='w-4 h-4' />
       <span>MOCK.SYSTEM</span>
      </div>
      <p className='text-[10px] leading-relaxed max-w-[200px] text-muted-foreground/80'>
       Advanced interview simulation environment powered by neural networks and
       adaptive learning algorithms.
      </p>
      <div className='flex items-center gap-2 text-[10px]'>
       <div className='w-2 h-2 rounded-full bg-green-500 animate-pulse' />
       <span>SYSTEM ONLINE</span>
      </div>
     </div>

     {/* Product */}
     <div className='space-y-4'>
      <h4 className='font-bold text-foreground uppercase tracking-widest'>
       Product
      </h4>
      <ul className='space-y-2'>
       <li>
        <Link to='/product' className='hover:text-primary transition-colors'>
         overview
        </Link>
       </li>
       <li>
        <Link to='/changelog' className='hover:text-primary transition-colors'>
         changelog
        </Link>
       </li>
       <li>
        <Link to='/demo' className='hover:text-primary transition-colors'>
         demo_mode
        </Link>
       </li>
      </ul>
     </div>

     {/* Company */}
     <div className='space-y-4'>
      <h4 className='font-bold text-foreground uppercase tracking-widest'>
       Company
      </h4>
      <ul className='space-y-2'>
       <li>
        <Link to='/about' className='hover:text-primary transition-colors'>
         about_us
        </Link>
       </li>
       <li>
        <Link to='/blog' className='hover:text-primary transition-colors'>
         engineering_blog
        </Link>
       </li>
       <li>
        <a
         href='https://github.com/mock-system'
         target='_blank'
         rel='noopener noreferrer'
         className='hover:text-primary transition-colors flex items-center gap-1'
        >
         github
        </a>
       </li>
      </ul>
     </div>

     {/* Legal */}
     <div className='space-y-4'>
      <h4 className='font-bold text-foreground uppercase tracking-widest'>
       Legal
      </h4>
      <ul className='space-y-2'>
       <li>
        <Link to='/terms' className='hover:text-primary transition-colors'>
         terms_of_service
        </Link>
       </li>
       <li>
        <Link to='/privacy' className='hover:text-primary transition-colors'>
         privacy_policy
        </Link>
       </li>
       <li>
        <Link to='/cookies' className='hover:text-primary transition-colors'>
         cookies_policy
        </Link>
       </li>
      </ul>
     </div>
    </div>

    {/* Bottom Bar */}
    <div className='border-t border-border/50 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] uppercase tracking-wider'>
     <div>
      &copy; {currentYear} MOCK INTERVIEW PLATFORM. ALL RIGHTS RESERVED.
     </div>
     <div className='flex items-center gap-4'>
      <span>v2.0.4-BETA</span>
      <span>|</span>
      <span>LATENCY: 24MS</span>
      <span>|</span>
      <span>REGION: EU-WEST</span>
     </div>
    </div>
   </div>
  </footer>
 );
}
